<div class="navbar navbar-default navbar-fixed-top">
  <div class="navbar-header">
    <div class="container-fluid" style="display: flex; align-items: center; height: 51px">
      <img src="./assets/images/enel_logo.png" alt="Enel X" style="height:37px; width:37px; margin-right: 5px;"/>
      <a href="/home" style="text-decoration: none; color:inherit;font-size: 18px;font-weight: 500;"> Venway </a>
    </div>
  </div>
  @if(isLogged) {
    <div>
      <ul class="nav navbar-nav">
        <li> <a id="home" href="/home">Home</a></li>
        <li class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">OADR<span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li> <a id="ven" href="/vens">Vens</a></li>
            <li> <a id="vtn" href="/vtns">Vtns</a></li>
            <li> <a id="registration" href="/registrations">Registrations</a></li>
            <li> <a id="cert" href="/certs">Certs</a></li>
            <li> <a id="payload" href="/payloads">Payloads</a></li>
          </ul>
        </li>
        <li class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Event<span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li><a href="/events">Events</a></li>
            <li role="separator" class="divider"></li>
            <li><a href="/groups">Groups</a></li>
            <li><a href="/resources">Resources</a></li>
            <li><a href="/marketContexts">Market Contexts</a></li>
            <li><a href="/platforms">Platform configs</a></li>
          </ul>
        </li>
        <li class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Reporting<span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li><a href="/metadataReports">Metadata Reports</a></li>
            <li><a href="/registeredReports">Registered Reports</a></li>
            <li><a href="/rids">RIDs</a></li>
            <li><a href="/powertypes">Powertypes</a></li>
            <li><a href="/channels">Channels</a></li>
          </ul>
        </li>
        <li class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Actions<span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li *ngIf="isAdmin()"><a href="/actionRequestEvent">Request Event</a></li>
            <li *ngIf="isAdmin()"><a href="/actionGenerateMetadataReport">Generate Metadata Report</a></li>
            <li *ngIf="isAdmin()"><a href="/actionGenerateUpdateReport">Generate Update Report</a></li>
            <li *ngIf="isAdmin()"><a href="/actionRegisterReports">Register Reports</a></li>
            <li *ngIf="isAdmin()"><a href="/actionSendReport">Send Report</a></li>
            <li><a href="/actionSendBackfillReport">Send Backfill Report</a></li>
          </ul>
        </li>
        <li class="dropdown" *ngIf="isAdmin()">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Admin<span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li><a href="/systemProperties">System Properties</a></li>
            <li><a href="/scheduler">Scheduler</a></li>
          </ul>
        </li>
      </ul>
      <div style="display: flex; justify-content: end; align-items: center; height: 51px">
        <div style="margin-right: 10px">
          {{username}}
        </div>
        <div style="margin-right: 10px">
          {{role}}
        </div>
        <button (click)="logout()" class="btn btn-default" style="margin-right: 10px"> Logout </button>
      </div>
    </div>
  }
</div>
<div style="padding: 60px 20px;">
  <router-outlet> </router-outlet>
</div>
